import { useNormalizeReferences } from 'hooks/useNormalizeReferences';
import { useEditController } from 'react-admin';
import { Role } from 'types/embedded/role';

import { RolesEditFormSkeleton } from './RolesEditFormSkeleton';
import { RolesForm } from '../components/RolesForm/RolesForm';

export const RolesEditForm: React.FC = () => {
  const { record } = useEditController<Role>();
  const { ready } = useNormalizeReferences({ referenceFields: ['roleCategories'] });

  if (!ready) {
    return <RolesEditFormSkeleton />;
  }

  return <RolesForm defaultOrderStatuses={record?.allowedStatusesEditing} />;
};
